import { Box, Typography } from '@mui/material'
import siaStyles from '@/components/Settings/SiaSettingsContent.module.scss'

export function SiaSettingsFooter() {
  return (
    <Box component="footer" className={siaStyles.footer}>
      <Typography variant="body2" component="p" className={siaStyles.footerText}>
        Voice input is processed on your device, but transcripts of your requests may be sent to Apple.{' '}
        <button type="button" className={siaStyles.footerLink}>About Sia, Dictation &amp; Privacy…</button>
      </Typography>
      <Typography variant="body2" component="p" className={siaStyles.footerText}>
        Sia Intelligence is built for privacy. Your data is not shared with Apple.{' '}
        <button type="button" className={siaStyles.footerLink}>About Sia Intelligence &amp; Privacy…</button>
      </Typography>
    </Box>
  )
}
